import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { CoreService } from 'src/app/services/core.service';
import { LoaderService } from 'src/app/services/loader.service';
import { CartStorage } from 'src/app/storage/cart';

@Component({
  selector: 'app-promo-t2',
  templateUrl: './promo-t2.component.html',
  styleUrls: ['./promo-t2.component.scss']
})
export class PromoT2Component {
  defImgProd:string = "assets/img/logo_nina_placeholder.jpg"
  products: any = [];
  dataPromo: any = null;
  dataBranch: any = null;
  promo:string = "";
  selectedProductsCart:any = [];
  btnDisabled:boolean = true;

  constructor(private cdr: ChangeDetectorRef, private loaderService:LoaderService, private coreService:CoreService, public apiServices: ApiService, public cookies: CookieService, public route: ActivatedRoute, public router: Router){
    if(this.cookies.check('DataPromo') && (this.cookies.check('Branch') || this.cookies.check('BranchTemp'))){
      this.dataPromo = JSON.parse(this.cookies.get('DataPromo'))
      if(this.cookies.check('Branch')){
        this.dataBranch = JSON.parse(this.cookies.get('Branch'))
      }
      else if(this.cookies.check('BranchTemp')){
        this.dataBranch = JSON.parse(this.cookies.get('BranchTemp'))
      }
      else{
        this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "No se encontraron datos de la sucursal"} });
        this.router.navigate(['/promotions'])
      }
      this.getProducts()
    }
    else{
      this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "No se encontraron datos de la promoción"} });
      this.router.navigate(['/promotions'])
    }
  }

  ngOnInit(): void {
  
  }

  getProducts(){
    let data = { token: this.cookies.get('Token'), idSucursal:this.dataBranch.idSucursal, idOferta: this.dataPromo.idPromo, idCliente: this.dataPromo.idCliente }
    this.loaderService.show()
    this.apiServices.getProductosPromoDDPorSucursal(data).subscribe({
      next: (value) => {
        // console.log(value)
        this.promo = value.tituloPromocion
        this.products = value.listaDeProductos;
        if(value.listaDeProductos.length === 0){
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: {text: "Esta promoción no esta disponible el día de hoy, pero puedes disfrutar otras disponibles"} });
          this.router.navigate(['/promotions'])
          return;
        }
        this.loaderService.hide()
        this.cdr.detectChanges();},
      error: (err) => {
        this.loaderService.hide()
      }
    })
  }

  changeQty(action: string, product: any) {
    const itemIndex = this.selectedProductsCart.findIndex(
      (p: any) => p.idProducto === product.idProducto
    );

    if (itemIndex === -1 && action === "sumar"){
      product.qty = 1
      product.promo = true
      product.idPromo = this.dataPromo.idPromo
      product.tipo = 2
      this.selectedProductsCart.push(product)
    }
    else{
      const item = this.selectedProductsCart[itemIndex];
      
      switch (action) {
        case "sumar":
          if (item.qty < product.existencia) {
            item.qty++;
          } 
          else {
            this.coreService.emitSubjet.next({
              type: "Snackbar",
              payload: { text: "No hay suficiente existencia de este producto :(" }
            });
          }
        break;
  
        case "restar":
          if(itemIndex === -1){
            this.coreService.emitSubjet.next({
              type: "Snackbar",
              payload: { text: "Acción no permitida" }
            });
          }
          else{
            if (item.qty > 0) {
              item.qty--;
              if(item.qty === 0){
                this.selectedProductsCart.splice(itemIndex, 1);
              }
            }
          }
        break;
      }
    }
  }

  preventTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  proceder(){
    let cartProds = []
    if(CartStorage.exists()){
      cartProds = CartStorage.getCart()
      this.selectedProductsCart.forEach((element:any) => {
        cartProds.push(element)
      });
    }
    else{
      this.selectedProductsCart.forEach((element:any) => {
        cartProds.push(element)
      });
    }
    const tomorrow = new Date();
    tomorrow.setHours(0, 0, 0, 0);
    tomorrow.setDate(tomorrow.getDate() + 1);
    CartStorage.saveCart(cartProds)
    if(!this.cookies.check('Branch')){
      this.cookies.set('Branch', JSON.stringify(this.dataBranch), {expires: tomorrow, sameSite: 'Strict'})
      if(this.cookies.check('BranchTemp')){
        this.cookies.delete('BranchTemp', '/');
      }
    }
    this.coreService.emitSubjet.next({ type: 'Cart', payload: null});
    this.router.navigate(['/cart'])
  }
}
